<template>
  <v-layout class='wrapper' row wrap>
    <main-banner/>
    <v-flex xs12 sm6 offset-sm3>
      <v-card class="my-2 mx-4">
        <v-card-text>
          <div class="mb-2">
            Hello {{ changePasswordData.username }}, please change your password:
          </div>
          <PasswordField
            class="form-field"
            label="New Password"
            id="new-password"
            v-model="newPassword"
            @keyup.enter="loginNewUser"
          />
          <v-text-field
            class="form-field"
            label="Password Confirmation"
            id="password-confirmation"
            v-model="passwordConfirmation"
            type="password"
            @keyup.enter="loginNewUser"
          ></v-text-field>
          <PasswordRequirements
            :badPassword="badPassword"
          />
          <div
            v-if="matchingError"
            class="red--text"
          >
            Passwords do not match
          </div>
          <v-btn
            class="mx-0 login-button"
            @click="loginNewUser"
            id="login-button"
            color="secondary"
          >
            Login
          </v-btn>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import MainBanner from 'Components/MainBanner.vue'
  import PasswordField from '@/components/PasswordTextField.vue'
  import PasswordRequirements from 'Components/PasswordRequirements.vue'
  import LoginPage from 'Mixins/LoginPage.js'
  import { mapState } from 'vuex'

  export default {
    name: 'new-user-confirmation',
    components: {
      MainBanner,
      PasswordField,
      PasswordRequirements
    },
    mixins: [LoginPage],
    data () {
      return {
        newPassword: '',
        passwordConfirmation: '',
        signupPath: '',
        matchingError: false,
        badPassword: false
      }
    },
    computed: {
      ...mapState({
        changePasswordData: state => state.cognito.changePasswordData
      })
    },
    methods: {
      loginNewUser () {
        if (this.newPassword === this.passwordConfirmation) {
          const { newPassword } = this
          const { username, oldPassword } = this.changePasswordData
          this.login({ username, password: oldPassword, newPassword })
            .then(() => {
              this.getUserAndPlans()
            }).catch(err => {
              console.log(err)
              this.badPassword = true
            })
        } else {
          this.matchingError = true
        }
      }
    }
  }
</script>

<style lang="scss">
  .wrapper {
    background-color: #4b91e3;
    height: 100%
  }

  .login-button {
    width: 100%;
    background-color: #4185DE;
    color: white;
  }
</style>
